import type { Uuid } from "@/domains/global/identifiers";

export enum AudioRecordingSuggestionStatus {
  Idle = "IDLE",
  WaitingForUpload = "WAITING_FOR_UPLOAD",
  WaitingForProcessing = "WAITING_FOR_PROCESSING",
  AwaitingSuggestion = "AWAITING_SUGGESTION",
  Ready = "READY",
  Error = "ERROR",
}

export type AudioRecordingSuggestionState = {
  status: AudioRecordingSuggestionStatus;
  errorMessage: string | null;
};

export interface IAudioSuggestionStore {
  getSuggestionState({
    audioRecordingId,
  }: {
    audioRecordingId: Uuid;
  }): AudioRecordingSuggestionState;
  isSuggestionReady({ audioRecordingId }: { audioRecordingId: Uuid }): boolean;
}
